<template>
  <v-dialog
      v-model="dialog"
      max-width="600"
  >
    <v-card v-if="app !== ''">
      <v-card-title class="text-h5">
        Einrichtung: {{appName}}
      </v-card-title>
       <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="(stepName, index) in stepNames[app]">
              <v-stepper-step
                  :key="`${index+1}-step`"
                  :complete="e1 > index+1"
                  :step="index+1"
              >
                {{stepName}}
              </v-stepper-step>

              <v-divider
                  v-if="index !== stepNames[app].length-1"
                  :key="index+1"
              ></v-divider>
            </template>
          </v-stepper-header>
          <v-stepper-items v-if="app === 'tb'">
            <v-stepper-content step="1">
              <v-row>
                <v-col>
                  <h6 class="m-0">Scannen Sie den QR-Code um die App herunterzuladen.</h6>
                </v-col>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                  <img style="height: 400px; width: 400px; margin-left: auto; margin-right: auto;" :src="`/img/${app}_playstore.png`"></img>
                <v-spacer></v-spacer>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <v-btn text  @click="closeDialog">
                  Abbrechen
                </v-btn>
                <v-btn
                    color="primary"
                    @click="e1 = 2"
                >
                  Weiter
                </v-btn>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-row>
                <v-col>
                  <h6 class="m-0">Folgen Sie den Anweisungen in der App und scannen Sie diesen QR-Code, wenn Sie dazu aufgefordert werden. Dannach in der App bestätigen.</h6>
                </v-col>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <img style="height: 400px; width: 400px; margin-left: auto; margin-right: auto;" :src="`https://bisoffice.com/api/qr/${tbApiKey}`"></img>
                <v-spacer></v-spacer>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <v-btn text  @click="closeDialog">
                  Abbrechen
                </v-btn>
                <v-btn
                    color="primary"
                    @click="e1 = 3; queryTans()"
                >
                  Weiter
                </v-btn>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-row>
                <v-col>
                  <h6 class="m-0">Bestätigen Sie die TAN Nummer welche Ihnen von der App angezeigt wird.</h6>
                </v-col>
              </v-row>
              <v-row class="m-4" style="">
                <v-spacer></v-spacer>
                <v-otp-input
                    v-model="currentTan"
                    disabled
                    length="8"
                    type="text"
                ></v-otp-input>
                <v-spacer></v-spacer>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <v-btn text @click="closeDialog">
                  Abbrechen
                </v-btn>
                <v-btn
                    color="warning"
                    @click="sendRegister(false)"
                    style="margin-right: 8px"
                    :disabled="currentTan === ''"
                >
                  Andere Tan
                </v-btn>
                <v-btn
                    color="primary"
                    @click="sendRegister(true)"
                    :disabled="currentTan === ''"
                >
                  Bestätigen
                </v-btn>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
          <v-stepper-items v-else-if="app === 'bk'">
            <v-stepper-content step="1">
              <v-row>
                <v-col>
                  <h6 class="m-0">Scannen Sie den QR-Code um die App herunterzuladen.</h6>
                </v-col>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                  <img style="height: 400px; width: 400px; margin-left: auto; margin-right: auto;" :src="`/img/${app}_playstore.png`"></img>
                <v-spacer></v-spacer>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <v-btn text  @click="closeDialog">
                  Abbrechen
                </v-btn>
                <v-btn
                    color="primary"
                    @click="e1 = 2"
                >
                  Weiter
                </v-btn>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-row>
                <v-col>
                  <h6 class="m-0">Folgen Sie den Anweisungen in der App und scannen Sie diesen QR-Code, wenn Sie dazu aufgefordert werden.</h6>
                </v-col>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <img style="height: 400px; width: 400px; margin-left: auto; margin-right: auto;" :src="bkQrUrl"></img>
                <v-spacer></v-spacer>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <v-btn text  @click="closeDialog">
                  Abbrechen
                </v-btn>
                <v-btn
                    color="primary"
                    @click="$emit('success');closeDialog();"
                >
                  Fertig
                </v-btn>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
          <v-stepper-items v-else-if="app === 'as' || app === 'to'">
            <v-stepper-content step="1">
              <v-row>
                <v-col>
                  <h6 class="m-0">Scannen Sie den QR-Code um die App herunterzuladen.</h6>
                </v-col>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                  <img style="height: 400px; width: 400px; margin-left: auto; margin-right: auto;" :src="`/img/${app}_playstore.png`"></img>
                <v-spacer></v-spacer>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <v-btn text  @click="closeDialog">
                  Abbrechen
                </v-btn>
                <v-btn
                    color="primary"
                    @click="e1 = 2;onCreateOneShotVerification();"
                >
                  Weiter
                </v-btn>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-row>
                <v-col>
                  <h6 class="m-0">Folgen Sie den Anweisungen in der App und scannen Sie diesen QR-Code, wenn Sie dazu aufgefordert werden.</h6>
                </v-col>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <img style="height: 400px; width: 400px; margin-left: auto; margin-right: auto;" :src="currentLoginQr"></img>
                <v-spacer></v-spacer>
              </v-row>
              <v-row class="m-0">
                <v-spacer></v-spacer>
                <v-btn text  @click="closeDialog">
                  Abbrechen
                </v-btn>
                <v-btn
                    color="primary"
                    @click="$emit('success');closeDialog();"
                >
                  Fertig
                </v-btn>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
         <v-stepper-items v-if="app === '6' || app === 'kloon'">
           <v-stepper-content step="1">
             <v-row>
               <v-col>
                 <h6 class="m-0">Scannen Sie den QR-Code um die App herunterzuladen.</h6>
               </v-col>
             </v-row>
             <v-row class="m-0">
               <v-spacer></v-spacer>
               <img style="height: 400px; width: 400px; margin-left: auto; margin-right: auto;" :src="`/img/${app}_playstore.png`"></img>
               <v-spacer></v-spacer>
             </v-row>
             <v-row class="m-0">
               <v-spacer></v-spacer>
               <v-btn text  @click="closeDialog">
                 Abbrechen
               </v-btn>
               <v-btn
                   color="primary"
                   @click="e1 = 2"
               >
                 Weiter
               </v-btn>
             </v-row>
           </v-stepper-content>
           <v-stepper-content step="2">
             <v-row>
               <v-col>
                 <h6 class="m-0">Wenn Sie nach dem Lizenzschlüssel gefragt werden, geben Sie nachfolgenden Code ein.</h6>
               </v-col>
             </v-row>
             <v-row class="m-4" style="">
               <v-spacer></v-spacer>
               <v-otp-input
                   v-model="kloonKey"
                   disabled
                   length="6"
                   type="text"
               ></v-otp-input>
               <v-spacer></v-spacer>
             </v-row>
             <v-row class="m-0">
               <v-spacer></v-spacer>
               <v-btn text @click="closeDialog">
                 Abbrechen
               </v-btn>
               <v-btn
                   color="primary"
                   @click="$emit('success');closeDialog();"
               >
                 Fertig
               </v-btn>
             </v-row>
           </v-stepper-content>
         </v-stepper-items>

       </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import {Server_URL} from "@/shared/utils";
import {Server_URL_ZK} from "@/shared/utils";

export default {
  name: "setup_app_dialog",
  props: {
    app: {
      type: String,
      default: 'tb'
    },
    kloonKey: {
      type: String,
      default: ''
    },
    mitaGischl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      possibleApps: [
        {name: 'PS Tagesbericht Erfassung', value: 'tb'},
        {name: 'Baumkontrolle', value: 'bk'}, // /zk/basis_data/qr
        {name: 'Team:o - Teamorganisator', value: 'to'},
        {name: 'Alarmserver', value: 'as'},
        {name: 'GPS-Nachweis PRO', value: 'kloon'},
        {name: 'Spielplatzkontrolle', value: '6'},
      ],
      stepNames: {
        'tb': ['App herunterladen', 'Einrichten', 'Anmeldung bestätigen'],
        'bk': ['App herunterladen', 'Einrichten'],
        'to': ['App herunterladen', 'Einrichten'],
        'as': ['App herunterladen', 'Einrichten'],
        '6': ['App herunterladen', 'Einrichten'],
        'kloon': ['App herunterladen', 'Einrichten'],
      },
      e1: 1,
      tans: [],
      tbApiKey: "",
      currentTan: "",
      currentPub: "",
      currentLoginQr: "",
      timer: null,
    }
  },
  computed: {
    appName () {
      return this.possibleApps.find(app => app.value === this.app).name
    },
    bkQrUrl () {
      return `${Server_URL_ZK}/zk/basis_data/qr`
    }
  },
  beforeDestroy() {
    console.log("clearing timer")
    clearInterval(this.timer)
  },
  methods: {
    closeDialog () {
      console.log("clearing timer")
      clearInterval(this.timer)
      this.timer = null;
      this.dialog = false
    },
    openDialog() {
      console.log(this.app)
      this.e1 = 1;
      this.currentTan = "";
      this.currentPub = "";
      if (this.app === 'tb') {
        this.$http.get(
            Server_URL+'/stammdaten/suite/tb_register'
        ).then(this.responseOkGetTb, this.responseErrorGet);
      }
      this.dialog = true;
    },

    onCreateOneShotVerification() {
      let aesKey = sessionStorage.getItem("aes");
      if (aesKey == null) {
        console.log("no encryption key, aborting");
        return;
      }
      let data = {
        auth_key: aesKey,
      };
      this.$http.post(
          Server_URL + '/um/osv/'+encodeURIComponent(this.mitaGischl + "-"), data, {responseType: 'blob'}
      ).then(this.responseOkOSV, this.responseErrorGet)
    },
    responseOkOSV(response) {
      if (response.status === 200) {
        response.blob().then(blob => {
          this.currentLoginQr = URL.createObjectURL(blob);
        });
      } else {
        console.log(response);
        this.$router.replace("/pages/500");
      }
    },
    responseOkGetTb(response) {
      if (response.status === 200) {
        this.tbApiKey = response.body.api_key;
        this.tans = response.body.tan_numbers;
        if (this.currentPub !== '') {
          if (this.currentTan !== '') {
            // register ok, close dialog
            this.$emit('success');
            this.closeDialog();
          } else {
            this.queryTans();
          }
        }
      } else {
        console.log(response);
      }
    },
    responseErrorGet(response) {
      this.hideLoader();
      //hide for now
      /*if (response.status === 401) {
        console.log(response);
        this.$router.replace("/pages/login");
      } else {
        console.log(response);
        this.$router.replace("/pages/500");
      }*/
    },
    queryTans() {
      this.timer = setInterval(() => {
        this.$http.get(
            Server_URL + '/stammdaten/suite/tb_register_new'
        ).then(this.responseOkGetTans, this.responseErrorGet);
      }, 500)
    },
    arrayContains(array, cond) {
      if (array === undefined || array === null || !Array.isArray(array)) {
        return false
      }
      for (let i = 0; i < array.length; i++) {
        if (array[i] === cond) {
          return true;
        }
      }
      return false;
    },
    sendRegister(accepted) {
      let payload = {
        tan: this.currentTan,
        pub: this.currentPub,
        accepted: accepted,
      }
      if (!accepted) {
        this.currentTan = "";
      }
      this.$http.post(
          Server_URL+'/stammdaten/suite/tb_register', payload
      ).then(this.responseOkGetTb, this.responseErrorGet);
    },
    responseOkGetTans(response) {
      if (response.status === 200) {
        let found = false;
        for (const [tan, public_key] of Object.entries( response.body)) {
          if (!this.arrayContains(this.tans, tan)) {
            this.currentTan = tan;
            this.currentPub = public_key;
            found = true;
            break;
          }
        }
        if (found) {
          clearInterval(this.timer)
        }
      } else {
        console.log(response);
      }},
  }
}
</script>

<style scoped>

::v-deep .theme--light.v-input--is-disabled input {
  color: black !important;
}

</style>
